import React, { useEffect, useMemo, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "./style.scss";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { resetCompanyName, setCompanyName } from "../../redux/auth";
import { LoginResponseType } from "../../redux/auth/authTypes";

type AppProps = {
  dispatchResetCompanyName: () => void;
  dispatchSetCompanyName: (data: string) => void;
  companyName: string;
  loginData: LoginResponseType;
};

const Breadcrumbs = ({
  dispatchResetCompanyName,
  dispatchSetCompanyName,
  companyName,
  loginData,
}: AppProps) => {
  const location: any = useLocation();
  const history: any = useHistory(); // useMemo to memoize the history object
  const finalTabFromPath = history?.location?.pathname.split("#")[1]
    ? "#" + history?.location?.pathname.split("#")[1]
    : location?.hash;
  const pathnames = location.pathname.split("/").filter((x: any) => x);
  const searchParams = location.search
    ? new URLSearchParams(location?.search)
    : new URLSearchParams(history?.location?.pathname.split("?")[1]);
  const tabs = useRef("");
  const clientCodeFromParams = searchParams.get("client_code");
  const { id }: any = useParams();
  const companyNameFromParams = searchParams.get("company_name");
  const type = searchParams.get("type");
  const client_code = !!location?.state?.client_code
    ? location?.state?.client_code
    : clientCodeFromParams
    ? clientCodeFromParams
    : id?.includes("#")
    ? id?.split("#")[0]
    : id;

  const side_id = history?.location?.state?.job_id;
  const final_client_code = useRef(client_code);
  const side_menu_id = useRef(side_id);

  let isAdmin =
    history?.location?.pathname?.includes("admin-reports") ||
    history?.location?.pathname?.includes("checklist");
  const final_company_name = location?.state?.company_name
    ? location?.state?.company_name
    : companyNameFromParams;

  useEffect(() => {
    if (!!final_company_name && final_company_name?.length > 0) {
      dispatchSetCompanyName(final_company_name);
    }
  }, [final_company_name]);

  useEffect(() => {
    if (!client_code) {
      dispatchResetCompanyName();
    }
  }, [client_code]);

  useEffect(() => {
    if (!!finalTabFromPath && finalTabFromPath?.length > 0) {
      tabs.current = finalTabFromPath;
    }
  }, [finalTabFromPath]);

  const MemoizedComponent = useMemo(() => {
    let newPathName: any = [];

    for (let i = 0; i < pathnames?.length; i++) {
      if (pathnames[i] === "file-managers" || pathnames[i] === "file-manager") {
        newPathName.push(pathnames[i]);
        break;
      }
      if (
        pathnames[i] === "client-dashboard" ||
        !isNaN(+pathnames[i]) ||
        !isNaN(pathnames[i]?.split("?")[0]) ||
        !isNaN(+pathnames[i][0])
      ) {
        continue;
      } else {
        newPathName.push(pathnames[i]);
      }
    }

    const changeFormat = (text: string) => {
      let newText = text.split("-");
      switch (text) {
        case "hr-dashboard":
          return "HR Dashboard";
        case "officer-directory":
          return "Officer's Directory";
        case "hrms":
          return "HRMS";
        case "add-ocr":
          return "Add OCR"
        case "sops":
          return "SOPs";
        case "tds-master":
          return "TDS Master";
        case "pending-wfh":
          return "Pending WFH";
        case "pending-wfh-details":
          return "Pending WFH Details";
          case "add-gst-compare":
            return "Add"

        default:
          return newText?.length > 0
            ? newText
                ?.map(
                  (item: string) =>
                    item?.trim()?.charAt(0)?.toUpperCase() +
                    item?.trim()?.slice(1) +
                    " "
                )
                ?.join(" ")
            : text[0]?.toUpperCase() + text?.slice(1) + " ";
      }
    };

    return (
      <div className="flex-center pl-3 breadCrum">
        {final_client_code.current ? (
          <div style={{ cursor: "pointer" }} className="text">
            <div className="flex-center">
              <div
                className="text"
                onClick={() => {
                  dispatchResetCompanyName();
                  history?.push("/");
                }}
              >
                Home&nbsp;
              </div>
              <div
                onClick={(e) => {
                  const finalUrl = `/client-dashboard/${
                    final_client_code.current ? final_client_code.current : ""
                  }`;

                  history.replace({
                    pathname: finalUrl,
                    state: {
                      client_code: final_client_code.current,
                      company_name: final_company_name
                        ? final_company_name
                        : companyName,
                      side_menu_id,
                    },
                  });
                }}
                style={{
                  cursor: newPathName?.length === 0 ? "default" : "pointer",
                }}
                className={newPathName?.length === 0 ? "bold-text" : "text"}
              >{`\u00A0/\u00A0${
                !!(final_company_name ? final_company_name : companyName)
                  ? final_company_name
                    ? final_company_name
                    : companyName
                  : ""
              }(${final_client_code.current})${
                newPathName?.length === 0 ? "" : "\u00A0/\u00A0"
              }`}</div>
            </div>
          </div>
        ) : null}

        {newPathName.map((path: any, index: number) => {
          return (
            <span key={path} className="flex-center">
              {index > 0 && <div>&nbsp;/&nbsp;</div>}
              <div
                className={
                  index === newPathName?.length - 1 ? "bold-text" : "text"
                }
                style={{
                  cursor:
                    index === newPathName?.length - 1 ? "default" : "pointer",
                }}
                onClick={() => {
                  if (index !== newPathName?.length - 1) {
                    const generatedUrl =
                      !!final_client_code.current && !isAdmin
                        ? `/${newPathName.slice(0, index + 1).join("/")}/${
                            final_client_code.current
                          }${type ? `#${type}` : ""}`
                        : `/${newPathName.slice(0, index + 1).join("/")}`;
                    history.replace({
                      pathname: generatedUrl,
                      state: !!location?.state?.client_code
                        ? location?.state
                        : {
                            ...location,
                            state: {
                              client_code: final_client_code,
                              company_name: final_company_name
                                ? final_company_name
                                : companyName,
                              side_menu_id,
                            },
                          },
                    });
                  }
                }}
              >
                {changeFormat(path)}
              </div>
            </span>
          );
        })}
      </div>
    );
  }, [pathnames]);

  return MemoizedComponent;
};

const mapStateToProps = (state: RootState) => ({
  companyName: state.auth.companyName,
  loginData: state.auth.loginData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetCompanyName: () => dispatch(resetCompanyName()),
  dispatchSetCompanyName: (data: string) => dispatch(setCompanyName(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs);
